import './index.css';
import { Link } from 'react-router-dom';

const sportFeatures = [
  { title: 'Discover', text: 'Browse activities by day on Explore, or see what\'s nearby on the Map.' },
  { title: 'Join in a tap', text: 'Check the time, location and spots left, then join. You can leave before the cut-off if plans change.' },
  { title: 'Activities & events', text: 'Activities are casual play sessions. Events are studio-hosted experiences with posters, ticket tiers and pay-on-site pricing.' },
  { title: 'Book venues & trainers', text: 'Browse venues and trainers, pick a slot and request a booking. Many studios confirm on-site, so it shows as pending until approved.' },
  { title: 'My Bookings', text: 'Venue holds, trainer sessions and joined activities are all tracked in one place on your profile.' },
  { title: 'Chat', text: 'Every joined session has a chat for meet-ups and last-minute changes.' },
];

const studioFeatures = [
  { title: 'Schedule', text: 'See today\'s activities and events at a glance, filter by type, and create new ones.' },
  { title: 'Activities vs events', text: 'Publish repeating, casual activities players join, or ticketed events with posters, tiers and sale windows.' },
  { title: 'Manage venues', text: 'Add courts and spaces, set opening hours, approval rules and recurring booking options.' },
  { title: 'Bookings & approvals', text: 'Review pending venue and trainer booking requests, approve or decline — status syncs back to the player instantly.' },
  { title: 'Trainer profiles', text: 'Set up offerings and rates so clients can book sessions straight from Posa Sport.' },
  { title: 'Payouts', text: 'Add your bank details for secure payouts, handled through our payment partner Paystack.' },
];

const FeatureGrid = ({ items }) => (
  <div className="cards">
    {items.map((f) => (
      <div key={f.title} className="card">
        <h3 style={{ margin: 0, fontSize: 18 }}>{f.title}</h3>
        <p style={{ margin: '8px 0 0', color: '#555' }}>{f.text}</p>
      </div>
    ))}
  </div>
);

const HowItWorks = () => {
  return (
    <main style={{ padding: '72px 0 56px', minHeight: '80vh' }}>
      <div className="container" style={{ maxWidth: '900px' }}>
        <h1 style={{ fontSize: '36px', marginBottom: '16px', color: '#14213D' }}>
          How Posa Works
        </h1>
        <p style={{ marginBottom: '48px', lineHeight: '1.6', color: '#475569', fontSize: '18px' }}>
          Posa is a platform of two apps that work together: <strong>Posa Sport</strong>, where players
          discover and join activities, and <strong>Posa Studio</strong>, where venues, studios and trainers
          run their business. Players discover you in Posa Sport — you run the show in Posa Studio.
        </p>

        <section style={{ marginBottom: '56px' }}>
          <h2 style={{ fontSize: '26px', marginBottom: '8px', color: '#14213D' }}>
            Posa Sport — for players
          </h2>
          <p style={{ marginBottom: '24px', lineHeight: '1.6', color: '#475569' }}>
            Play more, plan less. Find pick-up games, studio events, venues and trainers near you, then join
            in a tap.
          </p>
          <FeatureGrid items={sportFeatures} />
        </section>

        <section style={{ marginBottom: '56px' }}>
          <h2 style={{ fontSize: '26px', marginBottom: '8px', color: '#14213D' }}>
            Posa Studio — for venues, studios & trainers
          </h2>
          <p style={{ marginBottom: '24px', lineHeight: '1.6', color: '#475569' }}>
            Run your sports business from one schedule. Publish activities and ticketed events, manage
            venues, and handle bookings — Posa Sport brings the players to you.
          </p>
          <FeatureGrid items={studioFeatures} />
        </section>

        <section style={{
          marginBottom: '16px',
          padding: '24px',
          borderRadius: '12px',
          backgroundColor: '#F8FAFC',
          border: '1px solid #e5e7eb'
        }}>
          <h2 style={{ fontSize: '20px', marginTop: 0, marginBottom: '8px', color: '#14213D' }}>
            How the two apps connect
          </h2>
          <p style={{ margin: 0, lineHeight: '1.6', color: '#475569' }}>
            Both apps share the same backend, so what a studio publishes or approves in Posa Studio appears
            instantly to players in Posa Sport, and booking requests made in Posa Sport show up in Posa
            Studio for confirmation.
          </p>
        </section>

        <div style={{ marginTop: '48px', paddingTop: '24px', borderTop: '1px solid #e5e7eb' }}>
          <Link
            to="/"
            style={{
              color: '#007AFF',
              textDecoration: 'none',
              fontWeight: '500'
            }}
          >
            ← Back to Home
          </Link>
        </div>
      </div>
    </main>
  );
};

export default HowItWorks;
